export default __webpack_public_path__ + "static/media/ic_car_block.2e2355cc.svg";